<template lang="pug">
  #admin-super-maps-center
    WtTile(ancestor)
      WtTile(vertical :col="12")
        WtTile(parent :col="12")
          // FEATURED MAPS
          WtTile(
            child
            :col="12"
          )
            .title Featured Maps
            BTable(
              :data="featuredMaps"
              detailed
              :columns="columns"
            )
              template(slot="detail" slot-scope="props")
                section.section
                  WtTitle(card-title) Stride Map Description
                    span.is-size-7.pl-2 (legacy has its own descriptions via beta/adminsuper)
                  WtWysiwyg#map-description-wysiwyg.pb-6(selector="#map-description-wysiwyg" :content.sync="props.row.description")
                  .is-flex.is-justify-content-end
                    WtButton(@click.native="updateMapDescription(props.row)" :loading="updatingMap") Update Map

                section.section
                  WtTitle(card-title) Other fields that are shared with Legacy
                  p.pt-2 Image:
                  span.pl-2.has-text-teal {{ props.row.image }}
                  img(:src="props.row.image")
                  p.pt-2 Image Large:
                  span.pl-2.has-text-teal {{ props.row.imageLarge }}
                  p.pt-2 Email Template:
                  span.pl-2.has-text-teal {{ props.row.emailTemplate }}
                  p.pt-2 Poster:
                  span.pl-2.has-text-teal {{ props.row.poster }}
        // WELLNESS MAPS
        WtTile(parent :col="12")
          WtTile(
            child
            :col="12"
          )
            .title Wellness Maps
            BTable(
              :data="wellnessMaps"
              detailed
              :columns="columns"
            )
              template(slot="detail" slot-scope="props")
                section.section
                  WtTitle(card-title) Stride Map Description
                    span.is-size-7.pl-2 (legacy has its own descriptions via beta/adminsuper)
                  WtWysiwyg#map-description-wysiwyg.pb-6(selector="#map-description-wysiwyg" :content.sync="props.row.description")
                  .is-flex.is-justify-content-end
                    WtButton(@click.native="updateMapDescription(props.row)" :loading="updatingMap") Update Map

                section.section
                  WtTitle(card-title) Other fields that are shared with Legacy
                  p.pt-2 Image:
                  span.pl-2.has-text-teal {{ props.row.image }}
                  img(:src="props.row.image")
                  p.pt-2 Image Large:
                  span.pl-2.has-text-teal {{ props.row.imageLarge }}
                  p.pt-2 Email Template:
                  span.pl-2.has-text-teal {{ props.row.emailTemplate }}
                  p.pt-2 Poster:
                  span.pl-2.has-text-teal {{ props.row.poster }}
        WtTile(parent :col="12" v-if="isAdminIsDev")
          WtTile(
            child
            :col="6"
          )
            .title Add Wellness Maps
            BField(label="Program ID:")
              BInput(v-model="addWellnessMapsToProgramId")
            WtButton(@click.native="addWellnessMaps" :loading="addingMaps") Add
          WtTile(
            child
            :col="6"
          )
            .title Add Active Catalog
            BField(label="Program ID:")
              BInput(v-model="addActiveMapCatalogToProgramId")
            WtButton(@click.native="addActiveMapCatalog" :loading="addingMaps") Add

</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtWysiwyg from "@@/WtWysiwyg/WtWysiwyg";

export default {
  name: "AdminSuperMapsCenterWrapper",

  components: { WtButton, WtTile, WtTitle, WtWysiwyg },

  data() {
    return {
      error: null,
      featuredMaps: [],
      wellnessMaps: [],
      addWellnessMapsToProgramId: null,
      addActiveMapCatalogToProgramId: null,
      addingMaps: false,
      updatingMap: false,
      mapDescription: "",
      columns: [
        {
          field: "id",
          label: "id",
          width: "40",
          numeric: true
        },
        {
          field: "name",
          label: "Name"
        },
        {
          field: "userViewable",
          label: "Is Member Viewable by Default?"
        }
      ],
      openRow: null
    };
  },

  computed: {
    isAdminIsDev() {
      // fow now keeping usage to a minimum
      let isProd = process.env.VUE_APP_ENV === "prod";
      let isBen = this.$auth.user().email.includes("ben");
      let isMichel = this.$auth.user().email.includes("michel");
      let isDev = isBen || isMichel;

      return (isProd && isDev) || !isProd;
    }
  },

  async mounted() {
    try {
      const response = await this.axios.get("programs/featured-maps");
      this.featuredMaps = response.data.data
        .filter(map => !map.isWellnessChallenge)
        .sort((mapA, mapB) => mapB.userViewable - mapA.userViewable)
        .map(map => {
          map.userViewable = map.userViewable ? "yes" : "no";
          return map;
        });

      this.wellnessMaps = response.data.data
        .filter(map => !!map.isWellnessChallenge)
        .sort((mapA, mapB) => mapB.userViewable - mapA.userViewable)
        .map(map => {
          map.userViewable = map.userViewable ? "yes" : "no";
          return map;
        });
    } catch (error) {
      this.error = true;
    }
  },

  methods: {
    async addWellnessMaps() {
      this.addingMaps = true;
      await this.axios.post(
        `programs/${this.addWellnessMapsToProgramId}/add-maps`,
        { allWellnessMapIds: 1 }
      );
      this.addingMaps = false;
    },

    async addActiveMapCatalog() {
      this.addingMaps = true;
      await this.axios.post(
        `programs/${this.addActiveMapCatalogToProgramId}/add-maps`,
        { activeCatalog: 1 }
      );
      this.addingMaps = false;
    },

    async updateMapDescription(map) {
      this.updatingMap = true;
      await this.axios.put(`programs/update-map`, {
        mapId: map.id,
        description: map.description
      });
      this.updatingMap = false;
    }
  }
};
</script>

<style lang="sass" scoped></style>
